import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @memberof geodata
 */
class ContainsCollectionQuery extends ActiveRecord {
}
ContainsCollectionQuery.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordGeobufSource,
};
export default ContainsCollectionQuery;
